<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  country: string;
}>();

const iconClass = computed(() => {
  const country = props.country.toLowerCase();
  // TV-833 - we need to fake the flag icon for Taiwan
  if (country === 'tw') {
    return '';
  }

  return `flag-icon flag-icon-${country}`;
});
</script>

<template>
  <i v-if="iconClass" :class="iconClass" />
</template>

<style scoped></style>
